import { render } from "./Viajes.vue?vue&type=template&id=4eff6175&scoped=true"
import script from "./Viajes.vue?vue&type=script&lang=js"
export * from "./Viajes.vue?vue&type=script&lang=js"

import "./Viajes.vue?vue&type=style&index=0&id=4eff6175&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eff6175"]])

export default __exports__